export const ErrorImages = [
  {
    401: 'https://httpstatusdogs.com/img/401.jpg',
    403: 'https://httpstatusdogs.com/img/403.jpg',
    404: 'https://httpstatusdogs.com/img/404.jpg',
    412: 'https://httpstatusdogs.com/img/412.jpg',
    422: 'https://httpstatusdogs.com/img/422.jpg',
    500: 'https://httpstatusdogs.com/img/500.jpg',
    501: 'https://httpstatusdogs.com/img/501.jpg',
    502: 'https://httpstatusdogs.com/img/502.jpg',
    503: 'https://httpstatusdogs.com/img/503.jpg',
    504: 'https://httpstatusdogs.com/img/504.jpg',
    506: 'https://httpstatusdogs.com/img/506.jpg',
    507: 'https://httpstatusdogs.com/img/507.jpg',
    508: 'https://httpstatusdogs.com/img/508.jpg',
    509: 'https://httpstatusdogs.com/img/509.jpg',
    510: 'https://httpstatusdogs.com/img/510.jpg',
  }
]